
export { createPlayer } from './player';

export function readValue(element: any) {
    return element?.value;
}

export function setValue(element: any, value: string) {
    if (element?.value !== null) {
        element.value = value;
    }
}

export function selectText(element: any) {
    if (element?.value?.length) {
        element.setSelectionRange(0, element.value.length)
    }
}

export function getBoundingClientRect(element: HTMLElement) {
    let rect = element?.getBoundingClientRect();
    if (!rect) {
        return null;
    }
    return { height: rect.height, width: rect.width };
}

export function getParentBoundingClientRect(element: HTMLElement) {
    let rect = element?.parentElement?.getBoundingClientRect();
    if (!rect) {
        return null;
    }
    return { height: rect.height, width: rect.width };
};

export function getWindowSize() {
    return { height: window.innerHeight, width: window.innerWidth };
};

export function getFirstChild(element: any) {
    const child = element?.firstChild;
    return child;
}
